import api from "../api";
import config from "../config";

export const oauthService = {
  start: async ({ provider, flow, country_code, accept_terms, share_contacts }) => {
    const res = await api.post(`${config.apiBaseUrl}/api/oauth/start/`, {
      provider,
      flow,
      ...(country_code ? { country_code } : {}),
      ...(accept_terms !== undefined ? { accept_terms } : {}),
      ...(share_contacts !== undefined ? { share_contacts } : {}),
    });
    return res.data;
  },

  exchange: async ({ provider, code, state }) => {
    const res = await api.post(`${config.apiBaseUrl}/api/oauth/exchange/`, {
      provider,
      code,
      state,
    });
    return res.data;
  },

  unlink: async ({ provider }) => {
    const res = await api.delete(
      `${config.apiBaseUrl}/api/oauth/links/${provider}/`,
    );
    return res.data;
  },
};
